'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Hidden = require('./Hidden');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Hidden).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/Hidden/index.js
// module id = 186
// module chunks = 35783957827783 94702618338223 114276838955818 176428621896646